module.exports = fox._r("images/promo/mob-start-icon.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/mob-start-icon.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/mob-start-icon.png
// module id = 181
// module chunks = 2